import React from 'react';
import { View, StyleSheet } from 'react-native';
import {
  SkeletonGroup,
  SkeletonBone,
  SkeletonCard,
  SkeletonSection,
  SkeletonList,
  SkeletonListItem,
} from '@/components/common/skeleton';

interface Props {
  stacked?: boolean;
}

export const DesktopPaymentsViewSkeleton: React.FC<Props> = ({ stacked }) => (
  <SkeletonGroup style={stacked ? styles.columnsStacked : styles.columnsRow}>
    {/* Left Column: Balance, Methods, Autopay, Recurring */}
    <View style={[stacked ? styles.cellFull : styles.cellWide, styles.column]}>
      {/* Balance card */}
      <SkeletonCard>
        <SkeletonBone width={80} height={14} />
        <SkeletonBone width={140} height={32} />
        <SkeletonBone width="100%" height={40} borderRadius={8} />
      </SkeletonCard>

      {/* Payment methods */}
      <SkeletonSection headerWidth={140}>
        <View style={styles.methodsRow}>
          <SkeletonCard style={styles.methodCard}>
            <SkeletonBone width="70%" height={16} />
            <SkeletonBone width="50%" height={14} />
          </SkeletonCard>
          <SkeletonCard style={styles.methodCard}>
            <SkeletonBone width="70%" height={16} />
            <SkeletonBone width="50%" height={14} />
          </SkeletonCard>
        </View>
      </SkeletonSection>

      {/* Autopay */}
      <SkeletonSection headerWidth={100}>
        <SkeletonCard>
          <SkeletonBone width="60%" height={16} />
          <SkeletonBone width="40%" height={14} />
        </SkeletonCard>
      </SkeletonSection>

      {/* Recurring charges */}
      <SkeletonSection headerWidth={160}>
        <SkeletonBone width="100%" height={14} />
        <SkeletonBone width="100%" height={14} />
        <SkeletonBone width="80%" height={14} />
      </SkeletonSection>
    </View>

    {/* Right Column: Transaction History */}
    <View style={[stacked ? styles.cellFull : styles.cellNarrow, styles.column]}>
      <SkeletonSection headerWidth={180}>
        <SkeletonList count={6} gap={8}>
          <SkeletonListItem avatar={false} lines={2} lineWidths={['80%', '40%']} />
        </SkeletonList>
      </SkeletonSection>
    </View>
  </SkeletonGroup>
);

const GRID_GAP = 20;

const styles = StyleSheet.create({
  columnsRow: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: GRID_GAP,
  },
  columnsStacked: {
    gap: GRID_GAP,
  },
  column: {
    gap: GRID_GAP,
  },
  cellWide: {
    flex: 3,
    minWidth: 0,
  },
  cellNarrow: {
    flex: 2,
    minWidth: 0,
  },
  cellFull: {
    flex: 1,
  },
  methodsRow: {
    flexDirection: 'row',
    gap: 12,
  },
  methodCard: {
    flex: 1,
  },
});
